import { useMemo } from 'react'
import { type PermissionList } from '@terros/common'
import { useSelectedWorkflow } from '@hooks'
import { useFeature, useLoadedEntitlement, useProfile, type GroupedPermissionDefinitions } from '@front/model'
import { buildDisplayPermissionsRecord, type PermissionFilter } from './util'

export const usePermissionDisplayFilter = (): PermissionFilter => {
  const { shouldUseWorkflow } = useSelectedWorkflow()
  const { isTantalim } = useProfile()
  const isRecorderEnabled = useLoadedEntitlement('recording')
  const { isEnabled: isAIEnabled } = useFeature({ featureId: 'Feature:TerrosAIChat' })

  return useMemo(
    () => ({ isWorkflowEnabled: shouldUseWorkflow, isRecorderEnabled, isAIEnabled, isTantalim }),
    [shouldUseWorkflow, isRecorderEnabled, isAIEnabled, isTantalim]
  )
}

export const useDisplayPermissionsRecord = (permissionList: PermissionList): GroupedPermissionDefinitions => {
  const filter = usePermissionDisplayFilter()

  return useMemo(() => buildDisplayPermissionsRecord(permissionList, filter), [permissionList, filter])
}
